import React from 'react';
import PropTypes from 'prop-types';
import RoundInfographic from 'Components/RoundInfographic';

const EmptyStateIcon = ({
  button,
  color,
}) => (
  <RoundInfographic button={button}>
    <svg width="40" height="40" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10 10V2C10 1.46957 10.2107 0.960859 10.5858 0.585786C10.9609 0.210714 11.4696 0 12 0H38C38.5304 0 39.0391 0.210714 39.4142 0.585786C39.7893 0.960859 40 1.46957 40 2V28C40 28.5304 39.7893 29.0391 39.4142 29.4142C39.0391 29.7893 38.5304 30 38 30H30V37.986C30 39.098 29.102 40 27.986 40H2.014C1.74944 40.0003 1.48743 39.9483 1.24297 39.8472C0.998497 39.7461 0.776371 39.5978 0.589301 39.4107C0.402232 39.2236 0.253891 39.0015 0.152772 38.757C0.0516517 38.5126 -0.000262114 38.2506 9.95121e-07 37.986L0.00600104 12.014C0.00600104 10.902 0.904001 10 2.02 10H10ZM14 10H27.986C29.098 10 30 10.898 30 12.014V26H36V4H14V10ZM26 14H4.006L4 36H26V14ZM13.006 32L5.934 24.928L8.762 22.1L13.006 26.344L21.49 17.858L24.318 20.686L13.006 32Z"
        fill={color}
      />
    </svg>
  </RoundInfographic>
);

EmptyStateIcon.propTypes = {
  button: PropTypes.bool,
  color: PropTypes.string,
};

EmptyStateIcon.defaultProps = {
  button: true,
  color: 'var(--k-ds-color-grey-500)',
};

export default EmptyStateIcon;
